/**
 * @prettier
 */

// React Packages
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import RotateIcon from '../assets/svg/RotateIcon';

const IconButton = ({
    branding = null,
    isDisabled = false,
    className = '',
    outlined = false,
    isFocused = false,
    handleClick = () => {},
    ...props
}) => {
    const [colorState, setColorState] = useState(null);
    const primaryColor = branding?.data?.company_branding?.primary_color;

    const handleButtonClick = () => {
        if (isDisabled) return;
        handleClick();
    };

    const handleKeyDown = event => {
        if (isDisabled) return;
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick();
        }
    };

    useEffect(() => {
        if (primaryColor) {
            setColorState(primaryColor);
        }
    }, [primaryColor]);

    return (
        <div
            className={`icon-button ${className}`}
            role='button'
            tabIndex={isDisabled ? -1 : 0}
            aria-disabled={isDisabled}
            aria-label={props.label}
            onClick={handleButtonClick}
            onKeyDown={event => {
                if (isDisabled) return;
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    handleButtonClick();
                }
            }}
        >
            <RotateIcon
                size='25'
                className='icon-button__icon'
                infillColor={colorState}
                alt=''
            />
        </div>
    );
};
function mapStateToProps(state) {
    return {
        branding: state.config.profile,
    };
}
function mapDispatchToProps(dispatch) {}
export default connect(mapStateToProps, mapDispatchToProps)(IconButton);
